import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './Components/App';
import RTL from "./Components/RTL";
import {Provider} from 'react-redux';
import store from './Store';

render(
    <Provider store={store}>
        <BrowserRouter>
            <RTL>
                <App/>
            </RTL>
        </BrowserRouter>
    </Provider>
    , document.getElementById('root'));
